import { useParams } from 'react-router-dom';
import { useQueryParams } from '../../../lib/useQueryParams';
import { useState } from 'react';
import { DisclaimerModal } from './components/DisclaimerModal';
import { Query } from '../../../components/Query';
import { api } from '../../../lib/api';
import { styled, Typography } from '@mui/material';
import { Button } from '../../../components/Button';
import { computeReadableDate } from '../../../lib/date';
import { SignatureImage } from '../../../components/SignatureImage';
import { OPTIN_TEXTS } from '../constants';

function DroitImagePreview() {
    const params = useParams<{ droitImageId: string }>();
    const queryParams = useQueryParams(['role']);
    const isRoleAdmin = queryParams.role === 'admin';
    const [isDisclaimerModalOpen, setIsDisclaimerModalOpen] = useState(isRoleAdmin === false);
    const { droitImageId } = params;
    if (!droitImageId) {
        return <div>Missing parameters in URL</div>;
    }
    return (
        <Query
            queryKey={['droit-image-entries', droitImageId]}
            apiCall={() => api.getDroitImageEntry(droitImageId)}
        >
            {(data) => {
                const readableBirthDate = computeReadableDate(new Date(data.birthDate));
                const readableDate = computeReadableDate(new Date(data.created_at));
                return (
                    <ContentContainer className="no-padding-print">
                        <Row>
                            <LogoContainer>
                                <Logo src="https://www.esaj.asso.fr/assets/images/logo-sos.svg" />
                            </LogoContainer>
                            <Column>
                                <Title variant="h2">FORMULAIRE DE DROIT À L'IMAGE</Title>
                            </Column>
                        </Row>

                        <MainContentContainer>
                            <Typography>
                                Je soussigné(e) {data.firstName.toUpperCase()}{' '}
                                {data.lastName.toUpperCase()}, né(e) le {readableBirthDate},{' '}
                                {OPTIN_TEXTS[data.optinStatus].radioButtonLabel}
                            </Typography>

                            {OPTIN_TEXTS[data.optinStatus].paragraphs.map((paragraph, index) => (
                                <Paragraph key={`paragraph-${index}`}>{paragraph}</Paragraph>
                            ))}
                        </MainContentContainer>

                        <RightCenteredRow>
                            <Column>
                                <Typography>
                                    Fait à {data.place} le {readableDate}
                                </Typography>
                                <SignatureImage
                                    src={data.signatureUrl}
                                    alt="signature du candidat"
                                />
                            </Column>
                        </RightCenteredRow>
                        <Row className="not-printable">
                            <Button fullWidth onClick={handlePrint} variant="contained">
                                Sauvegarder une copie du formulaire de droit à l'image
                            </Button>
                        </Row>

                        <DisclaimerModal
                            isOpen={isDisclaimerModalOpen}
                            close={closeDisclaimerModal}
                        />
                    </ContentContainer>
                );
            }}
        </Query>
    );

    function handlePrint() {
        window.print();
    }

    function closeDisclaimerModal() {
        setIsDisclaimerModalOpen(false);
    }
}

const MainContentContainer = styled('div')(({ theme }) => ({
    paddingTop: theme.spacing(16),
    paddingBottom: theme.spacing(16),
}));

const Logo = styled('img')(({ theme }) => ({
    width: '100px',
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
}));
const Row = styled('div')(({ theme }) => ({
    display: 'flex',
    flex: 1,
    alignItems: 'center',
}));

const RightCenteredRow = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    flex: 1,
    marginBottom: theme.spacing(4),
}));

const Paragraph = styled(Typography)(({ theme }) => ({
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
}));

const LogoContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: theme.spacing(4),
}));

const ContentContainer = styled('div')(({ theme }) => ({
    flex: 1,
    padding: theme.spacing(4),
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
}));

const Title = styled(Typography)(({ theme }) => ({
    textAlign: 'center',
    paddingBottom: theme.spacing(1),
}));

const Column = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
}));

export { DroitImagePreview };
